import AlphamoonMachineLearningEngineer from "./alphamoon_machine_learning_engineer.md";
import AlphamoonMachineLearningIntern from "./alphamoon_machine_learning_engineer_intern.md";

/* eslint-disable @typescript-eslint/no-explicit-any*/
export const experience_description: { [key: string]: any } = {
  alphamoon_machine_learning_engineer: AlphamoonMachineLearningEngineer,
  alphamoon_machine_learning_intern: AlphamoonMachineLearningIntern,
};
